import React from 'react'
import PropTypes from 'prop-types'
import { intl } from 'lang/intl'

import { IconComponent } from '../../../../components'
import { stripHash } from '../../../../utils'
import {
  useOverlayState,
  changeOverlay,
  removeOverlay,
} from '../../../../../firebase/hooks/useOverlays'
import { useWebinarColors } from '../../../../../Designs/blocs/useWebinarColors'

const QuestionOverlayButton = ({ question }) => {
  const overlay = useOverlayState()
  const webinarColors = useWebinarColors()

  const isQuestionOverlaid = question.comment_id === overlay?.id
  let style = { opacity: 0.3 }

  if (isQuestionOverlaid) {
    style = { opacity: 1, visibility: 'visible' }
  }

  const toggleQuestionOverlay = () => {
    if (isQuestionOverlaid) {
      removeOverlay()
    } else {
      changeOverlay({
        type: 'question',
        data: {
          name: question?.name ?? 'audience',
          text: question.content_text,
          id: question.comment_id,
        },
      })
    }
  }

  return (
    <IconComponent
      className="toggle-question-overlay-button"
      tooltip={
        isQuestionOverlaid
          ? intl.formatMessage({ defaultMessage: 'Remove from the video' })
          : intl.formatMessage({ defaultMessage: 'Display on the video' })
      }
      tooltipOptions={{ placement: 'topRight' }}
      name="views"
      size={[16, 16]}
      style={style}
      color={stripHash(webinarColors.tabs.contrast.color ?? '#FFF')}
      onClick={toggleQuestionOverlay}
    />
  )
}

QuestionOverlayButton.defaultProps = {}

QuestionOverlayButton.propTypes = {
  question: PropTypes.object,
}

export default QuestionOverlayButton
